import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_accounts_loader = _resolveComponent("accounts-loader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_location = _resolveComponent("location")!
  const _component_free_trials_editor = _resolveComponent("free-trials-editor")!
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_accounts_loader, {
      "account-type": _ctx.accountType,
      onLoaded: _ctx.onLoaded
    }, null, 8, ["account-type", "onLoaded"]),
    _createVNode(_component_q_table, {
      columns: _ctx.columns,
      rows: _ctx.filteredAccounts,
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
      loading: _ctx.isLoading,
      "wrap-cells": "",
      onRequest: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event.pagination))
    }, {
      "body-cell-name": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `/admin/accounts/${props.row.id}/users`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.value), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-location": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_location, {
              location: props.value
            }, null, 8, ["location"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-freeTrials": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_free_trials_editor, {
              "account-id": props.row.id,
              value: props.value,
              onUpdated: ($event: any) => (_ctx.onAccountTrialsUpdated(props.row.id, $event))
            }, null, 8, ["account-id", "value", "onUpdated"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-createdAt": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_humanize_time, {
              time: props.value
            }, null, 8, ["time"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination", "loading"])
  ]))
}